import { Trans } from 'react-i18next'

import { Warning } from '@phosphor-icons/react'
import { useTheme } from 'styled-components'

import { Text } from '@reveni-io/reveni-ui'

import { getOrdersName } from './helpers'
import * as Styles from './styles'

const NoChangeableOrdersMessage = ({ notUsableOrders }) => {
  const theme = useTheme()
  const notUsableOrdersNames =
    notUsableOrders?.length > 1 ? getOrdersName(notUsableOrders) : notUsableOrders[0]?.order?.name

  return (
    <Styles.AlertContainer>
      <Warning size={24} color={theme.colors.warning.hover} />
      <Text color={theme.colors.warning.onSurface} type="bodyMRegular">
        {notUsableOrders?.length > 1 ? (
          <Trans values={{ notUsableOrdersNames }} i18nKey="transactionsNotEditable">
            Las transacciones <strong>{{ notUsableOrdersNames }}</strong> no se pueden modificar.
          </Trans>
        ) : (
          <Trans values={{ notUsableOrdersNames }} i18nKey="transactionNotEditable">
            La transacción <strong>{{ notUsableOrdersNames }}</strong> no se puede modificar.
          </Trans>
        )}
      </Text>
    </Styles.AlertContainer>
  )
}

export default NoChangeableOrdersMessage
